export const LocalStorageEnums = {
    userInfo : 'userInfo'
};